$.fn.isInViewport = function(additional) {
    //console.log(additional);
    var elementTop = $(this).offset().top + additional;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};
$(window).on('resize scroll', function() {
    $("section").each(function() {
        if ($(this).isInViewport(500)) {
            if ($(this).hasClass('animation')) {
                $(this).addClass('playanimation');
            }
        }
    });
});
window.onload = function() {
    var is_mobile = isMobileView();
    if (is_mobile) {
        
    } else {
        //For Desktop View
        forDesktopJs();
    }
};

window.onresize = function() {
    var is_mobile = isMobileView();
    if (is_mobile) {

    } else {
        //For Desktop View
        forDesktopJs();
    }
};

// Function to detect browser size and return true if smaller than 768px
function isMobileView() {
    var windowWidth = window.innerWidth;

    if (windowWidth < 768) {
        return true;
    } else {
        return false;
    }
}

function forDesktopJs() { }

function forMobileJs() { }